import type { Require } from "types/utilTypes";

import { List, Record } from "immutable";

import { AccessReviewTemplateIntegrationRuleModel } from "./AccessReviewTemplateIntegrationRuleModel";
import { AccessReviewTemplateResourceRuleModel } from "./AccessReviewTemplateResourceRuleModel";

export type TAccessReviewTemplateReviewers = "manager" | "resourceOwner";
export type TFilterType = "exclude" | "include";

const defaults = {
  accessReviewsCount: null as null | number,
  createdAt: new Date(0),
  creatorId: "",
  description: "",
  groupFilterType: "exclude" as TFilterType,
  groupIds: [] as string[],
  id: "",
  immediateRevoke: false,
  includeUserless: true,
  integrationFilterType: "exclude" as TFilterType,
  integrationIds: [] as string[],
  integrationRules: null as List<AccessReviewTemplateIntegrationRuleModel> | null,
  isDeleted: false,
  name: "",
  resourceRules: null as List<AccessReviewTemplateResourceRuleModel> | null,
  reviewerTypes: [] as TAccessReviewTemplateReviewers[],
};

export type TFullTAccessReviewTemplateModel = Require<AccessReviewTemplateModel, "integrationRules" | "resourceRules">;

type TAccessReviewTemplateModel = typeof defaults;

export class AccessReviewTemplateModel extends Record<TAccessReviewTemplateModel>(defaults) {
  static fromServerData(data: unknown): AccessReviewTemplateModel {
    const {
      accessReviewsCount,
      createdAt,
      creatorId,
      description,
      groupFilterType,
      groupIds,
      id,
      immediateRevoke,
      includeUserless,
      integrationFilterType,
      integrationIds,
      integrationRules,
      isDeleted,
      name,
      resourceRules,
      reviewerTypes,
    } = data as TAccessReviewTemplateModel;
    return new AccessReviewTemplateModel({
      accessReviewsCount,
      createdAt: new Date(createdAt),
      creatorId,
      description,
      groupFilterType,
      groupIds,
      id,
      immediateRevoke,
      includeUserless,
      integrationFilterType,
      integrationIds,
      integrationRules: integrationRules
        ? List(integrationRules.map(AccessReviewTemplateIntegrationRuleModel.fromServerData))
        : null,
      isDeleted,
      name,
      resourceRules: resourceRules
        ? List(resourceRules.map(AccessReviewTemplateResourceRuleModel.fromServerData))
        : null,
      reviewerTypes,
    });
  }
}
